import { parse } from 'querystring';

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const getBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    // resolve(reader.result);
  });
};

/**
 * 计算字符串的总单位字符数，向上取整。
 * 通常由中文输入法输入的字符（如汉字、中文标点、全角符号）算1个单位。
 * 通常由英文输入法输入的字符（如英文字母、数字、英文标点、半角符号、emoji、空格）算0.5个单位。
 * @param str 输入字符串
 * @returns 总单位字符数（向上取整）
 */
export const calculateUnitCharCount = (str: string): number => {
  if (!str) {
    return 0;
  }

  let unitCount = 0;

  for (const char of str) {
    // 使用正则表达式判断是否为通常通过中文输入法输入的字符
    // 这个范围覆盖了中日韩统一表意文字及其扩展、常见中文标点以及全角字符
    if (/[\u3000-\u303F\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFF00-\uFFEF]/.test(char)) {
      unitCount += 1;
    } else {
      // 其他所有字符（通常由英文输入法输入）算半个单位
      unitCount += 0.5;
    }
  }

  return Math.ceil(unitCount); // 向上取整
};

export function extractIdXsecFromUrl(urlString: string) {
  try {
    const url = new URL(urlString);
    const pathnameParts = url.pathname.split('/');
    // note_id 是 /explore/ 后的部分
    const note_id = pathnameParts[pathnameParts.length - 1];

    const params = new URLSearchParams(url.search);
    const xsec_token = params.get('xsec_token');

    return {
      note_id: note_id,
      xsec_token: xsec_token
    };
  } catch (error) {
    console.error("无效的 URL:", error);
    return null;
  }
}
